import { useState } from 'react';
import { menuItems } from '../menuItems';
import MenuItems from './MenuItems';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      
      {/* HAMBURGER BUTTON (visible only on mobile via CSS) */}
      <div 
        className="hamburger"
        onClick={() => setIsOpen(prev => !prev)}
      >
        ☰
      </div>

      {/* MENU */}
      <ul className={`menus ${isOpen ? 'active' : ''}`}>
        {menuItems.map((menu, index) => (
          <MenuItems
            items={menu}
            key={index}
            depthLevel={0}
            closeMenu={() => setIsOpen(false)}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;